// src/components/SettingsLayout.jsx
import { Outlet } from "react-router-dom";
import SettingsNav from "./SettingsNav";
import "../styles/SettingsLayout.css";

export default function SettingsLayout() {
  return (
    <div className="settings-layout">
      <SettingsNav />
      <div className="settings-content">
        <Outlet />
      </div>
    </div>
  );
}
